<label mat-dialog-title class="partial-cancel-dialog-header">
  <span class="title">{{data.config.title}}</span><br />
  <span class="subtitle"
    ><b>{{data.config.description}}</b></span
  >
</label>

<mat-dialog-content style="max-height: max-content;">
  <div class="container-table">
    <app-data-table
        [type]="data.type"
        [data]="data.data"
        size="xl"
      >
      </app-data-table>
  </div>
  <p><small>{{data.config.footer}}</small></p>
</mat-dialog-content>

<mat-dialog-actions align="center" *ngIf="!data.config.hideButtons">
  <button
    *ngIf="!data.config.hideButtonCancel"
    mat-stroked-button
    id="cancelAction"
    (click)="onClose()"
    class="b-s m-2"
  >
    Cancelar
  </button>
  <button
    *ngIf="data.config.action"
    mat-flat-button
    (click)="onSubmitAction()"
    id="submitAction"
    [ngClass]="data.config.class"
    [disabled]="!data.data.length"
  >
    {{data.config.action}}
  </button>
</mat-dialog-actions>

<button
  mat-button
  id="closeAction"
  (click)="onClose()"
  class="dialog-close"
>
  <mat-icon>close</mat-icon>
</button>
